import { IUser } from '@/interfaces/common';

import userService from './user-service';

interface Handler {
  id: string;
  callback: (data: any) => void;
}

interface Handlers {
  [key: string]: Handler[];
}

declare global {
  interface Window {
    notificationsService: {
      addChannelGroup: (groups: Array<{ name: string; alias: string }>) => void;
      getEventDispatcher: () => any;
    };
  }
}

const notificationsService = window.notificationsService;
const eventDispatcher = notificationsService.getEventDispatcher();

const handlers: Handlers = {};

let instance: SubscriptionsNotificationsService;

class SubscriptionsNotificationsService {
  constructor() {
    userService.getMe((user: IUser) => {
      user &&
        notificationsService.addChannelGroup([
          {
            name: `$subscriptions.user.${user.id}`,
            alias: 'subscriptions',
          },
        ]);
    });

    this._bindEvents();
  }

  public addHandler(
    key: string,
    id: string,
    callback: (data: any) => void,
  ): void {
    if (!handlers[key]) {
      handlers[key] = [];
    }

    handlers[key].push({ id, callback });
  }

  private _runHandlers(key: string, data: any): void {
    if (!handlers[key]) {
      return;
    }

    handlers[key].forEach(handler => {
      handler.id === data.id && handler.callback(data);
    });
  }

  private _bindEvents(): void {
    const events = ['order.completed', 'order.failed'];

    if (eventDispatcher) {
      events.forEach(key => {
        eventDispatcher.subscribe(`subscriptions:${key}`, (data: any) => {
          this._runHandlers(key, data);
        });
      });
    }
  }

  public static getInstance(): SubscriptionsNotificationsService {
    if (!instance) {
      instance = new SubscriptionsNotificationsService();
    }

    return instance;
  }
}

export default SubscriptionsNotificationsService.getInstance();
